export function parseInteger(value: string) {
	return Number(value.replace(/[^\d]/g, ""))
}

export function toNumOrNull(value: unknown): number | null {
	if (value === null || value === undefined) return null
	const n = typeof value === "number" ? value : Number(value)
	return Number.isFinite(n) ? n : null
}

/**
 * Format a numeric value for display with thousand separators.
 * Returns fallback string for null, undefined, or non-finite values.
 */
export const formatNumber = (value: number | null | undefined, fallback = "0"): string => {
	if (value === null || value === undefined || !Number.isFinite(value)) {
		return fallback
	}
	return value.toLocaleString("en-US")
}
